import { ProjectId } from '@kaizenplatform/hugot-entity';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import Config from '../../core/Config';

class FilesWebApi {
  private readonly axios: AxiosInstance;
  private readonly tokenUrl: string;

  constructor() {
    this.axios = axios.create({
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    const config: Config = (window as any).__hugotconfig__;
    this.tokenUrl = `${config.HUGOT_API_BASE_URL}/files/authorize_token`;
  }

  public fetchToken = async (
    {
      type,
      projectId,
      bucketType,
      bucketId,
    }: {
      type: 'files' | 'bucket';
      projectId?: ProjectId;
      bucketType?: 'modification_request' | 'creative_brief';
      bucketId?: string;
    },
    options: AxiosRequestConfig = {},
  ): Promise<string> => {
    const response = await this.axios.post(
      this.tokenUrl,
      {
        type,
        project_id: projectId,
        bucket_type: bucketType,
        bucket_id: bucketId,
      },
      {
        ...options,
      },
    );

    return response.data.token as string;
  };
}

export default FilesWebApi;
